// import { QueryHookOptions, useQuery } from '@apollo/client';
// import { GetPaymentMethods } from '_graphql/queries/__generated__/GetPaymentMethods';
// import { getPaymentMethods } from '_graphql/queries/suppliers';

import { QueryHookOptions, useQuery } from "@apollo/client";
import { GetSupportedProviders, GetSupportedProvidersVariables } from "_graphql/queries/__generated__/GetSupportedProviders";
import { getSupportedProviders } from "_graphql/queries/suppliers";

// export const usePaymentMethods = (
//   options?: QueryHookOptions<GetPaymentMethods>
// ) => {
//   const { data, ...rest } = useQuery<GetPaymentMethods>(
//     getPaymentMethods,
//     options
//   );

//   return {
//     methods: data?.getPaymentMethods || [],
//     count: 120,
//     ...rest,
//   };
// };


export const useSupportedProviders = (options?: QueryHookOptions<GetSupportedProviders, GetSupportedProvidersVariables>) => {
    const { data, ...rest } = useQuery<GetSupportedProviders, GetSupportedProvidersVariables>(getSupportedProviders, {
        variables: options?.variables,
        fetchPolicy: 'network-only',
    });

    return {
        providers: data?.getSupportedProviders || [],
        count: 120,
        ...rest,
    };
}